import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from 'semantic-ui-react';
import { InspectedObjectDetailsDTO } from '@src/api/objectDetails/dto/InspectedObjectDetailsDTO';
import { getObjectTypeByKey, ObjectTypeType } from '@src/constants/objectType';
import SailorLink from '@src/components/CustomCell/SailorLink';
import styles from './ObjectDetails.module.scss';
import ObjectDetailsField from './ObjectDetailsField';

type Props = {
  objectDetailsDTO: InspectedObjectDetailsDTO;
};

function ElectricalObjectDetails({ objectDetailsDTO }: Props) {
  const { t } = useTranslation();
  const labelPrefix = 'electrical.object.details';

  const {
    buildingNumber,
    department,
    experiment,
    site,
    inspectedObjectId,
    inspectionId,
    inspectionSummaryId,
  } = objectDetailsDTO.objectDetailsElectrical;

  const inspectedObjectType: ObjectTypeType | undefined = getObjectTypeByKey(
    objectDetailsDTO.objectType
  );

  return (
    <Grid columns="equal" stackable className={styles.detailsContainer}>
      <Grid.Row className={styles.row}>
        <ObjectDetailsField
          field={t(`${labelPrefix}.buildingNumber`)}
          value={buildingNumber}
          icon="building"
        />
        <ObjectDetailsField field={t(`${labelPrefix}.department`)} value={department} />
        <ObjectDetailsField field={t(`${labelPrefix}.experiment`)} value={experiment} />
      </Grid.Row>
      <Grid.Row className={styles.row}>
        <ObjectDetailsField field={t(`${labelPrefix}.site`)} value={site} />
        <ObjectDetailsField
          field="SAILOR"
          value={
            inspectedObjectType && (
              <SailorLink
                objectType={inspectedObjectType}
                inspectionId={inspectionId}
                objectId={inspectedObjectId}
                inspectionSummaryId={inspectionSummaryId}
              />
            )
          }
        />
        <ObjectDetailsField field="" value="" />
      </Grid.Row>
    </Grid>
  );
}

export default ElectricalObjectDetails;
